import type { ReactNode } from 'react';

export interface TabItem {
  label: string;
  icon?: ReactNode;
  disabled?: boolean;
}

interface TabsProps {
  tabs: TabItem[];
  value: number;
  onChange: (index: number) => void;
  className?: string;
}

export default function Tabs({ tabs, value, onChange, className = '' }: TabsProps) {
  return (
    <div className={`border-b border-border ${className}`}>
      <nav className="-mb-px flex gap-0.5" aria-label="Onglets">
        {tabs.map((tab, index) => (
          <button
            key={index}
            type="button"
            onClick={() => !tab.disabled && onChange(index)}
            disabled={tab.disabled}
            className={`inline-flex items-center gap-2 border-b-2 px-4 py-3.5 text-sm font-medium transition-colors ${
              value === index
                ? 'border-primary-600 text-primary-600'
                : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700'
            } ${tab.disabled ? 'cursor-not-allowed opacity-50' : ''}`}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
